import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DotNestedKeys, nestedData } from '@sla-ng/core';
import { distinctUntilChanged, Observable, Subject, takeUntil } from 'rxjs';
import { map } from 'rxjs/operators';
import { ICostAccounting } from '../../../../../../models/cost-accounting.model';
import { ICostTypeCost } from '../../../../../../models/cost-type-cost.model';
import { ICostTypeCostLayout } from '../../../../../../models/layout/cost-type-cost-layout.model';
import { ICostAccountingState } from '../../../../../../services/facades/cost-accounting/cost-accounting-state.model';
import { CostAccountingFacade } from '../../../../../../services/facades/cost-accounting/cost-accounting.facade';
import { CostAccountingLayoutService } from '../../../../../../services/layout/cost-accounting-layout.service';

@Component({
    selector: 'app-cost-type-cost',
    templateUrl: './cost-type-cost.component.html',
    styleUrls: [ './cost-type-cost.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostTypeCostComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild(MatSort)
    public sort: MatSort;

    @Input()
    public selectedCostAccounting: ICostAccounting;

    public dataSource: MatTableDataSource<ICostTypeCost> = new MatTableDataSource<ICostTypeCost>([]);

    public costAccountingState$: Observable<ICostAccountingState>;
    public layout: ICostTypeCostLayout;
    private destroy$: Subject<void> = new Subject();


    constructor(private myCostAccountingFacade: CostAccountingFacade,
                private myCostAccountingLayoutService: CostAccountingLayoutService) {
    }

    public ngOnInit(): void {
        this.layout = this.myCostAccountingLayoutService.getCostTypeCostLayout();
        this.costAccountingState$ = this.myCostAccountingFacade.subState();

        this.costAccountingState$
            .pipe(
                takeUntil(this.destroy$),
                map((s: ICostAccountingState) => s.costTypeCosts),
                distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)))
            .subscribe((data: ICostTypeCost[]) => {
                this.dataSource.data = data;
            });

        this.dataSource.sortingDataAccessor = (item: ICostTypeCost, val: DotNestedKeys<ICostTypeCost>): number | string => {
            return nestedData(item, val) as number | string;
        };

        this.dataSource.filterPredicate = (item: ICostTypeCost, filter: string): boolean => {
            return item.costType.name.toLowerCase().indexOf(filter.trim().toLowerCase()) !== -1;
        };

    }

    public ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.myCostAccountingFacade.clearState();
    }



    public applyFilter(filterValue: string): void {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
}
